import { useEffect } from 'react';

import { authority, teamsConfig } from '~/services/oidc';

export const TeamsLogin = () => {
  useEffect(() => {
    const params = new URLSearchParams({
      ...teamsConfig,
      state: crypto.randomUUID(),
      nonce: crypto.randomUUID(),
    });
    const authUrl = `${authority}/protocol/openid-connect/auth?${params.toString()}`;
    window.location.replace(authUrl); // redirect popup to Keycloak
  }, []);

  return null;
};
